module.exports = __webpack_public_path__ + "static/media/ic_annotation_inverse.0f3137c9.svg";